import { Helmet } from 'react-helmet-async';

interface ArticleSchemaProps {
  title: string;
  excerpt: string;
  author: string;
  publishedAt: string;
  updatedAt?: string;
  featuredImage?: string;
  category?: string;
  tags?: string[];
  content: string;
  url: string;
  locale: string;
  isPremium?: boolean;
}

/**
 * Composant Schema.org BlogPosting pour rich snippets Google
 * https://schema.org/BlogPosting
 */
export function ArticleSchema({
  title,
  excerpt,
  author,
  publishedAt,
  updatedAt,
  featuredImage,
  category,
  tags,
  content,
  url,
  locale,
  isPremium = false,
}: ArticleSchemaProps) {
  // Compter les mots (approximatif)
  const wordCount = content.split(/\s+/).length;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: title,
    description: excerpt,
    image: featuredImage || 'https://aspexit.com/og-image.jpg',
    datePublished: publishedAt,
    dateModified: updatedAt || publishedAt,
    author: {
      '@type': 'Person',
      name: author,
      url: 'https://www.linkedin.com/in/corentin-leroux-0225a182/',
      jobTitle: 'Expert en Numérique Agricole',
      sameAs: [
        'https://www.linkedin.com/in/corentin-leroux-0225a182/',
        'https://twitter.com/CP_Leroux'
      ]
    },
    publisher: {
      '@type': 'Organization',
      name: 'Aspexit',
      logo: {
        '@type': 'ImageObject',
        url: 'https://aspexit.com/logo.png',
      },
      url: 'https://aspexit.com',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    ...(category && { articleSection: category }),
    ...(tags && tags.length > 0 && { keywords: tags.join(', ') }),
    wordCount,
    inLanguage: locale,
    isAccessibleForFree: isPremium ? 'False' : 'True',
    ...(isPremium && {
      hasPart: {
        '@type': 'WebPageElement',
        isAccessibleForFree: 'False',
        cssSelector: '.article-premium-content'
      }
    })
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
